var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4228 16.2987C25.5428 16.2987 28.0721 13.7694 28.0721 10.6494C28.0721 7.5293 25.5428 5 22.4228 5C19.3027 5 16.7734 7.5293 16.7734 10.6494C16.7734 13.7694 19.3027 16.2987 22.4228 16.2987Z",
    stroke: "#8A96A3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1796 33.5849C35.1796 27.872 29.4962 23.2515 22.499 23.2515C15.5018 23.2515 9.81836 27.872 9.81836 33.5849",
    stroke: "#8A96A3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94585 15.6712C8.56085 15.8307 8.21103 16.0645 7.91637 16.3591C7.7785 16.4962 7.55419 16.497 7.41711 16.3591C6.822 15.764 6.01487 15.4297 5.17327 15.4297C4.33166 15.4297 3.52453 15.764 2.92943 16.3591C2.33432 16.9542 2 17.7614 2 18.603C2 19.4446 2.33432 20.2517 2.92943 20.8468L6.95832 24.8769C7.34879 25.2675 7.98196 25.2676 8.37254 24.8771L12.404 20.8468C12.6987 20.5521 12.9325 20.2023 13.0919 19.8173C13.2514 19.4323 13.3335 19.0197 13.3335 18.603C13.3335 18.1862 13.2514 17.7736 13.0919 17.3886C12.9325 17.0036 12.6987 16.6538 12.404 16.3591C12.1094 16.0645 11.7596 15.8307 11.3746 15.6712C10.9896 15.5118 10.5769 15.4297 10.1602 15.4297C9.74348 15.4297 9.33085 15.5118 8.94585 15.6712Z",
    fill: "#8A96A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptions);
export default __webpack_public_path__ + "static/media/Subscriptions.95a6b0446db6ef16763f7370538b48ca.svg";
export { ForwardRef as ReactComponent };